import { useState } from "react";
import { useFormContext } from "react-hook-form";

import SelectStateModal from "../../TreatmentPage/modals/state-modal/SelectStateModal";

const GenericContactTabForHookForm = ({ statesAbrs, selectedState }) => {
  const { register, setValue, watch } = useFormContext();

  const formatNumber = (value) => {
    if (!value) return value;

    const phoneNumber = value.replace(/[^\d]/g, "");
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const handlePhoneInputChange = (event) => {
    const formattedValue = formatNumber(event.target.value);
    setValue("phone", formattedValue, { shouldValidate: true });
  };

  const handleFaxInputChange = (event) => {
    const formattedValue = formatNumber(event.target.value);
    setValue("fax", formattedValue, { shouldValidate: true });
  };

  const phoneValue = watch("phone");
  const faxValue = watch("fax");
  const [stateShow, setStateShow] = useState(false);
  const [, setSelectedState2] = useState(selectedState ? selectedState : null);
  const handleStateChange = (state) => {
    setValue("state", state.StateAbr);
    setSelectedState2(state.StateAbr);
  };

  const state = watch("state");

  return (
    <>
      <div className="row mx-0 align-items-center custom-margin-bottom">
        <div className="col-md-6 p-l-5 pe-0">
          <input
            type="text"
            placeholder="Address 1"
            className="form-control height-25 p-l-5 p-0 d-flex align-items-center"
            {...register("address")}
          />
        </div>
        <div className="col-md-6 p-l-5 p-r-5">
          <input
            type="text"
            placeholder="Address 2"
            className="form-control height-25 p-l-5 p-0 d-flex align-items-center"
            {...register("address1")}
          />
        </div>
      </div>

      {/* <div className="row align-items-center custom-margin-bottom">
        <div className="col-md-2 text-start">
          <span className="d-inline-block text-grey">Address 2:</span>
        </div>
        <div className="col-md-10">
          <input
            type="text"
            placeholder="Enter Address 2"
            className="form-control"
            {...register("address1")}
          />
        </div>
      </div> */}

      <div className="d-flex mx-0 align-items-center custom-margin-bottom">
        <div className="flex-g-1 p-l-5 pe-0">
          <input
            type="text"
            placeholder="City"
            className="form-control height-25 p-l-5 p-0 d-flex align-items-center"
            {...register("city")}
          />
        </div>

        {/* <div className="col-md-2">
          <select name="state" className="form-select form-control " {...register("state")}>
            {statesAbrs &&
              statesAbrs.map((state) => (
                <option
                  key={state.id}
                  selected={state.StateAbr === selectedState}
                  value={state.StateAbr}
                >
                  {state.name}
                </option>
              ))}
          </select>
        </div> */}
        {stateShow && (
          <SelectStateModal
            show={stateShow}
            handleClose={() => setStateShow(false)}
            onChange={handleStateChange}
            statesData={statesAbrs}
          />
        )}
        <div
          style={{
            width: "90px",
          }}
          className="position-relative p-l-5 height-25 custom-select-new-provider"
        >
          <div
            className="dropdown-button rounded-0 p-0 p-l-5 form-control height-25 d-flex align-items-center"
            onClick={() => setStateShow(true)}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === "Tab") {
                e.preventDefault();
                setStateShow(true);
              }
            }}
            tabIndex={0}
            role="button"
          >
            <span id="selectedOption">
              {state ? (
                <div className="d-flex align-items-center">
                  <svg
                    style={{
                      width: "15px",
                      height: "15px",
                      fill: "var(--primary-80)",
                      color: "var(--primary-80)",
                      stroke: "var(--primary-80)",
                    }}
                    className={`icon icon-state-${state}`}
                  >
                    <use xlinkHref={`#icon-state-${state}`} />
                  </svg>
                  {state}
                </div>
              ) : (
                "State"
              )}
            </span>
          </div>
        </div>

        <div
          style={{
            width: "100px",
          }}
          className=" p-l-5 p-r-5"
        >
          <input
            type="text"
            placeholder="Zip"
            className="form-control height-25 p-l-5 p-0 d-flex align-items-center"
            {...register("zip_code")}
          />
        </div>
      </div>

      <div className="row mx-0 align-items-center custom-margin-bottom">
        <div className="flex-g-1 p-l-5 p-r-5">
          <input
            type="text"
            placeholder="(###) ###-####"
            className="form-control height-25 p-l-5 p-0 d-flex align-items-center"
            {...register("phone", {
              // pattern: {
              //   value: /^\(\d{3}\) \d{3}-\d{4}$/,
              //   message: "Invalid phone number format please correct the format",
              // },
            })}
            value={phoneValue || ""}
            onChange={handlePhoneInputChange}
          />
        </div>
        <div
          className=""
          style={{
            width: "90px",
          }}
        >
          <input
            type="number"
            placeholder="Extension"
            className="form-control height-25 p-l-5 p-0 d-flex align-items-center"
            {...register("extension")}
          />
        </div>
        <div className="flex-g-1 p-l-5 p-r-5">
          <input
            type="text"
            placeholder="(###) ###-####"
            className="form-control height-25 p-l-5 p-0 d-flex align-items-center"
            {...register("fax", {
              // pattern: {
              //   value: /^\(\d{3}\) \d{3}-\d{4}$/,
              //   message: "Invalid Fax number format or correct the fax format",
              // },
            })}
            value={faxValue || ""}
            onChange={handleFaxInputChange}
          />
        </div>
      </div>

      <div className="row mx-0 align-items-center custom-margin-bottom">
        <div className="col-md-12 p-l-5 p-r-5">
          <input
            type="email"
            placeholder="Email"
            className="form-control height-25 p-l-5 p-0 d-flex align-items-center"
            {...register("email")}
          />
        </div>
      </div>
    </>
  );
};

export default GenericContactTabForHookForm;
